import { render, staticRenderFns } from "./PalettesList.vue?vue&type=template&id=72edc82a"
import script from "./PalettesList.vue?vue&type=script&lang=js"
export * from "./PalettesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports